var _style, _circle, _circle2, _path, _circle3, _path2, _circle4, _path3, _circle5, _path4, _circle6, _path5, _circle7, _path6, _circle8, _path7, _circle9, _path8, _circle0, _path9, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulticlock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:30.2177;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:10.0369;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 512,
    cy: 512,
    r: 388.87
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 512.17,
    cy: 512,
    r: 73.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.26,512c-1.04,0.3-1.99,0.57-2.95,0.84c-13.32,3.81-26.64,7.61-39.96,11.43c-3.17,0.91-6.28,0.84-9.28-0.57 c-4.2-1.97-6.73-5.29-7.44-9.88c-1.01-6.47,3.27-12.75,9.65-14.3c2.13-0.52,4.26-0.55,6.38,0.04c3.72,1.03,7.43,2.1,11.14,3.16 c8.24,2.35,16.48,4.71,24.72,7.07C555.07,510.52,557.63,511.25,560.26,512z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 512.17,
    cy: 319.2,
    r: 73.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.26,319.2c-1.04,0.3-1.99,0.57-2.95,0.84c-13.32,3.81-26.64,7.61-39.96,11.43 c-3.17,0.91-6.28,0.84-9.28-0.57c-4.2-1.97-6.73-5.29-7.44-9.88c-1.01-6.47,3.27-12.75,9.65-14.3c2.13-0.52,4.26-0.55,6.38,0.04 c3.72,1.03,7.43,2.1,11.14,3.16c8.24,2.35,16.48,4.71,24.72,7.07C555.07,317.72,557.63,318.45,560.26,319.2z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 512.17,
    cy: 704.8,
    r: 73.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.26,704.8c-1.04,0.3-1.99,0.57-2.95,0.84c-13.32,3.81-26.64,7.61-39.96,11.43 c-3.17,0.91-6.28,0.84-9.28-0.57c-4.2-1.97-6.73-5.29-7.44-9.88c-1.01-6.47,3.27-12.75,9.65-14.3c2.13-0.52,4.26-0.55,6.38,0.04 c3.72,1.03,7.43,2.1,11.14,3.16c8.24,2.35,16.48,4.71,24.72,7.07C555.07,703.32,557.63,704.05,560.26,704.8z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 319.37,
    cy: 512.34,
    r: 73.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.46,512.35c-1.04,0.3-1.99,0.57-2.95,0.84c-13.32,3.81-26.64,7.61-39.96,11.43 c-3.17,0.91-6.28,0.84-9.28-0.57c-4.2-1.97-6.73-5.29-7.44-9.88c-1.01-6.47,3.27-12.75,9.65-14.3c2.13-0.52,4.26-0.55,6.38,0.04 c3.72,1.03,7.43,2.1,11.14,3.16c8.24,2.35,16.48,4.71,24.72,7.07C362.27,510.86,364.83,511.59,367.46,512.35z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 319.37,
    cy: 319.54,
    r: 73.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.46,319.55c-1.04,0.3-1.99,0.57-2.95,0.84c-13.32,3.81-26.64,7.61-39.96,11.43 c-3.17,0.91-6.28,0.84-9.28-0.57c-4.2-1.97-6.73-5.29-7.44-9.88c-1.01-6.47,3.27-12.75,9.65-14.3c2.13-0.52,4.26-0.55,6.38,0.04 c3.72,1.03,7.43,2.1,11.14,3.16c8.24,2.35,16.48,4.71,24.72,7.07C362.27,318.06,364.83,318.79,367.46,319.55z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 319.37,
    cy: 704.11,
    r: 73.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.46,704.11c-1.04,0.3-1.99,0.57-2.95,0.84c-13.32,3.81-26.64,7.61-39.96,11.43 c-3.17,0.91-6.28,0.84-9.28-0.57c-4.2-1.97-6.73-5.29-7.44-9.88c-1.01-6.47,3.27-12.75,9.65-14.3c2.13-0.52,4.26-0.55,6.38,0.04 c3.72,1.03,7.43,2.1,11.14,3.16c8.24,2.35,16.48,4.71,24.72,7.07C362.27,702.63,364.83,703.36,367.46,704.11z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 704.97,
    cy: 511.31,
    r: 73.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M753.06,511.31c-1.04,0.3-1.99,0.57-2.95,0.84c-13.32,3.81-26.64,7.61-39.96,11.43 c-3.17,0.91-6.28,0.84-9.28-0.57c-4.2-1.97-6.73-5.29-7.44-9.88c-1.01-6.47,3.27-12.75,9.65-14.3c2.13-0.52,4.26-0.55,6.38,0.04 c3.72,1.03,7.43,2.1,11.14,3.16c8.24,2.35,16.48,4.71,24.72,7.07C747.87,509.83,750.43,510.56,753.06,511.31z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 704.97,
    cy: 319.2,
    r: 73.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M753.06,319.2c-1.04,0.3-1.99,0.57-2.95,0.84c-13.32,3.81-26.64,7.61-39.96,11.43 c-3.17,0.91-6.28,0.84-9.28-0.57c-4.2-1.97-6.73-5.29-7.44-9.88c-1.01-6.47,3.27-12.75,9.65-14.3c2.13-0.52,4.26-0.55,6.38,0.04 c3.72,1.03,7.43,2.1,11.14,3.16c8.24,2.35,16.48,4.71,24.72,7.07C747.87,317.72,750.43,318.45,753.06,319.2z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 704.97,
    cy: 704.11,
    r: 73.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M753.06,704.11c-1.04,0.3-1.99,0.57-2.95,0.84c-13.32,3.81-26.64,7.61-39.96,11.43 c-3.17,0.91-6.28,0.84-9.28-0.57c-4.2-1.97-6.73-5.29-7.44-9.88c-1.01-6.47,3.27-12.75,9.65-14.3c2.13-0.52,4.26-0.55,6.38,0.04 c3.72,1.03,7.43,2.1,11.14,3.16c8.24,2.35,16.48,4.71,24.72,7.07C747.87,702.63,750.43,703.36,753.06,704.11z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulticlock2);
export default __webpack_public_path__ + "static/media/multiclock2.7b6ed38b0cd18709af811bb9f1850573.svg";
export { ForwardRef as ReactComponent };